import React, {Component} from 'react';
import {Row, Col} from 'react-bootstrap';
import $ from 'jquery';
import c from '../../constants';
import {Link} from "react-router-dom";
import history from '../../history';
import LoaderNoticia from '../Loader/LoaderNoticia';

import '../../assets/css/Noticias.css';

import facebook from "../../assets/img/iconRed/facebookSR.png";
import whatsapp from "../../assets/img/iconRed/whatsappSR.png";
import twitter from "../../assets/img/iconRed/twitterSR.png";
import linkedin from "../../assets/img/iconRed/linkedin.png";
import PaginacionNoticias from "./PaginacionNoticias";


class Noticias extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fetching: null,
            noticias: null,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        $.ajax({
            url: this.props.match.params.page ? c.BASE_URL + "/noticias/" + this.props.match.params.page : c.BASE_URL + "/noticias",
            type: 'GET',
            cache: false,
            before: () => {
                this.setState({fetching: true})
            },
            success: (data) => {
                this.setState({noticias: data});
                console.log("data", data);
                this.setState({fetching: false});

            }
        });
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (nextProps.match.params.page != this.props.match.params.page) {
            window.scrollTo(0, 0);
            $.ajax({
                url: nextProps.match.params.page ? c.BASE_URL + "/noticias/" + nextProps.match.params.page : c.BASE_URL + "/noticias",
                type: 'GET',
                cache: false,
                before: () => {
                    this.setState({fetching: true})
                },
                success: (data) => {
                    this.setState({noticias: data});
                    console.log("data", data);
                    this.setState({fetching: false});

                }
            });
        }
    }

    goToNoticia(id) {
        history.push("/noticia" + "/" + id);
    }

    render() {
        let noticias = this.state.noticias ? this.state.noticias.map((noticia) => {
            //URL from current page
            const url = window.location.href + "noticia/" + (noticia ? noticia.idnoticia : "");
            //URL patterns for Social media sites share functionalities
            const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
            const twitterUrl = `https://twitter.com/home?status=${url}`;
            const linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}`;
            const whatsAppUrl = `https://wa.me/?text=${url}`;
            return (
                <div style={{paddingBottom: "80px"}}>
                    <img
                        src={'http://gruposensor.com/upload/noticias/' + (noticia ? noticia.idnoticia : "") + '/imagenes/big/' + (noticia ? noticia.img[0] : "")}/>
                    <h2 className="tituloNoticia">{noticia ? JSON.parse(noticia.titulo).es : ""}</h2>
                    <p className="copeteNoticia">
                        <div className="breve-descripcion"
                             dangerouslySetInnerHTML={{__html: noticia ? JSON.parse(noticia.breve_descripcion).es.substring(0, 120) + "[...]" : ""}}></div>
                    </p>
                    <br/>
                    <Link to={"/noticia" + "/" + (noticia ? noticia.idnoticia : "")}><a
                        className="notaCompleta">Leer noticia completa ></a></Link>
                    <div className="redesSociales">
                        <a target="_blank" href={facebookUrl}><img src={facebook}/></a>
                        <a target="_blank" href={twitterUrl}><img src={twitter}/></a>
                        <a target="_blank" href={linkedinUrl}><img src={linkedin}/></a>
                        <a target="_blank" href={whatsAppUrl}><img src={whatsapp}/></a>
                    </div>
                </div>
            )
        }) : null;

        return (
            <section className="noticias" style={{display: noticias && noticias.length == 0 ? "none" : "block"}}>
                <Row>
                    <Col md={8} className="noticia center-block">
                        {
                            this.state.fetching == true || this.state.fetching == null ? <LoaderNoticia/> :
                                <div>
                                    <h2>Noticias</h2>
                                    {noticias}
                                </div>
                        }
                    </Col>
                </Row>
                <PaginacionNoticias params={this.props.match.params.page ? this.props.match.params.page : 1}/>

            </section>
        );
    }
}

export default Noticias;